import Hashids from 'hashids';

const h = new Hashids('automately-crm-2026', 8);

export const encodeId = (id: number): string => h.encode(id);

export const decodeId = (hash: string): number | null => {
  try {
    const decoded = h.decode(hash);
    if (!decoded.length) return null;
    return decoded[0] as number;
  } catch {
    return null;
  }
};
